module.exports = __webpack_public_path__ + "static/media/logo.824721a3.svg";